'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagWwAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M0 0H28V20H0V0Z", fill: "#19BFBF" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 17.3333C18.0501 17.3333 21.3333 14.0501 21.3333 10C21.3333 5.94991 18.0501 2.66667 14 2.66667C9.94991 2.66667 6.66667 5.94991 6.66667 10C6.66667 14.0501 9.94991 17.3333 14 17.3333ZM19.9634 10.6667C19.7159 12.9058 18.2361 14.7736 16.2173 15.577C16.8674 14.253 17.2472 12.528 17.3203 10.6667H19.9634ZM15.9856 10.6667C15.8883 12.9157 15.3011 14.9034 14.3855 15.9878C14.258 15.9959 14.1295 16 14 16C13.8705 16 13.742 15.9959 13.6145 15.9878C12.6989 14.9034 12.1117 12.9157 12.0144 10.6667H15.9856ZM10.6797 10.6667C10.7528 12.528 11.1326 14.253 11.7827 15.577C9.76386 14.7736 8.28415 12.9058 8.03662 10.6667H10.6797ZM12.0144 9.33333H15.9856C15.8883 7.08429 15.3011 5.09657 14.3855 4.01219C14.258 4.0041 14.1295 4 14 4C13.8705 4 13.742 4.0041 13.6145 4.01219C12.6989 5.09657 12.1117 7.08429 12.0144 9.33333ZM11.7827 4.42302C11.1326 5.74705 10.7528 7.47197 10.6797 9.33333H8.03662C8.28415 7.09417 9.76386 5.22637 11.7827 4.42302ZM19.9634 9.33333H17.3203C17.2472 7.47197 16.8674 5.74705 16.2173 4.42302C18.2361 5.22637 19.7159 7.09417 19.9634 9.33333Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagWwAsset = forwardRef(FlagWwAsset);

export { VpFlagWwAsset as default };
